import HStack from './Layout/HStack';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomButtonV2 from './CustomButtonV2';
import AppText from './AppText';
import { Colors } from '../../styles/Colors';
import { GlobalStyleAttributes } from '../../styles/GlobalStyles';

const SelectChips = ({ options, selectedValue, onChange, testIDPrefix, containerStyle }) => {
    const getChipStyles = (option, isSelected, isHovered) => {
        if (isSelected) {
            return {
                backgroundColor: Colors.newDesign.lightBlue,
                color: Colors.newDesign.mainText,
                border: 'none',
                ...option.selectedStyle,
            };
        }
        return {
            backgroundColor: isHovered ? Colors.newDesign.avatarBgColor : Colors.newDesign.tableBackgroundColor,
            color: Colors.newDesign.mainText,
            border: 'none',
        };
    };

    return (
        <HStack space="0.625rem" flexWrap="wrap" padding="12px 24px">
            {options.map((option) => {
                const isSelected = selectedValue === option.value;

                return (
                    <CustomButtonV2
                        key={option.value}
                        onClick={() => onChange(option.value)}
                        testID={`${testIDPrefix}-${option.value}`}
                        override={({ isHovered }) => {
                            const style = getChipStyles(option, isSelected, isHovered);
                            return (
                                <HStack
                                    alignItems="center"
                                    space="0.5rem"
                                    style={{
                                        ...style,
                                        borderRadius: 100,
                                        padding: '6px 12px',
                                        cursor: 'pointer',
                                    }}>
                                    {option.icon && <FontAwesomeIcon icon={isSelected && option.selectedIcon ? option.selectedIcon : option.icon} fontSize={14} height={14} width={14} color={isSelected && option.selectedIconColor ? option.selectedIconColor : style.color} />}
                                    <AppText fontSize={GlobalStyleAttributes.fonts.heading3} boldFont={isSelected} style={{ color: style.color }}>
                                        {option.label}
                                    </AppText>
                                </HStack>
                            );
                        }}/>
                );
            })}
        </HStack>
    );
};

export default SelectChips;
